import type { PlannerCurrency } from '../model/host';
import { toUsdEstimate } from '@travel-planner/shared/utils/fx-convert';
import { useOptionalPlannerHost } from './planner-host';
import css from './planner-v3-usd.module.scss';

const NO_CURRENCY = (): PlannerCurrency => ({
  currencyFor: () => null,
  fx: null,
});

const USD = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

/**
 * "(est. $415)" beside a price in the member's currency (XT-883); nothing when
 * the host has no rates, the rate is unknown or it is already dollars.
 */
export const UsdEstimate = ({
  amount,
  currency,
}: {
  amount: number | null | undefined;
  currency: string | null | undefined;
}) => {
  const host = useOptionalPlannerHost();
  const useCurrency = host?.useCurrency ?? NO_CURRENCY;
  const { fx } = useCurrency();
  const code = (currency || 'EUR').toUpperCase();
  const usd =
    amount != null && amount > 0 && code !== 'USD'
      ? toUsdEstimate(amount, code, fx)
      : null;
  if (usd == null) return null;
  return (
    <span
      className={css.usd}
      title="Estimate in US dollars at XT's latest rate"
    >
      (est. {USD.format(usd)})
    </span>
  );
};
